// In-memory holder for the reading draft being revealed.
// Avoids passing large base64 images through router params.
let current = null;

export const readingSession = {
  set(draft) {
    current = draft;
  },
  get() {
    return current;
  },
  clear() {
    current = null;
  },
};
